import {lazy} from "react";

const UploadLoteHome = lazy(() => import("./UploadLoteHome"));

const uploadLoteRoutes = [
    {
        path: "/document-upload/:docTypeId",
        element: <UploadLoteHome/>,
    },
];

export default uploadLoteRoutes;